<template>
  <div>
    <div id="content" class="content" style="margin-left:0px;">
      <h1 class="page-header" style="text-align:left">
        出库管理
        <small>/&nbsp;出库单审核列表</small>
      </h1>

      <div
        id="page-container"
        class="in page-sidebar-fixed page-header-fixed"
        style="padding-top:0px;"
      >
        <!-- begin #content -->
        <div
          id="content"
          class="content"
          style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
        >
          <!-- begin breadcrumb -->

          <div class="row">
            <!-- begin col-10 -->
            <div class="col-lg-12">
              <!-- begin panel -->
              <div class="panel panel-inverse">
                <!-- begin panel-heading -->
                <div class="panel-heading">
                  <div class="panel-heading-btn">
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-default"
                      data-click="panel-expand"
                    >
                      <i class="fa fa-expand"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-success"
                      data-click="panel-reload"
                    >
                      <i class="fa fa-redo"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-warning"
                      data-click="panel-collapse"
                    >
                      <i class="fa fa-minus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-danger"
                      data-click="panel-remove"
                    >
                      <i class="fa fa-times"></i>
                    </a>
                  </div>
                  <h4 class="panel-title panelTitle">出库单审核列表</h4>
                </div>
                <!-- end panel-heading -->
                <!-- begin panel-body -->
                <div class="panel-body">
                  <form style="margin-top:16px;">
                    <fieldset>
                      <div class="form-group row m-b-15">
                        <label class="col-md-1 col-form-label">出库单号</label>
                        <div class="col-md-2">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="出库单号"
                            v-model="outCode"
                          >
                        </div>
                        <label class="col-md-1 col-form-label">服务商名称</label>
                        <div class="col-md-2">
                          <el-select
                            v-model="recomId"
                            style="width:100%;font-size:12px;"
                            clearable
                            filterable
                            placeholder="服务商名称"
                          >
                            <el-option
                              v-for="item in recomList"
                              :key="item.recomId"
                              :label="item.recomName"
                              :value="item.recomId"
                            ></el-option>
                          </el-select>
                        </div>
                        <label class="col-md-1 col-form-label">出库时间</label>
                        <div class="col-md-3">
                          <el-date-picker
                            style="width:100%;height:34px;"
                            v-model="TimeValue"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="ChangePicker"
                          ></el-date-picker>
                        </div>
                        <div class="col-md-1">
                          <a class="btn btn-primary ButtonColor m-r-5" @click="SearchClick()">查询</a>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                  <el-table :data="purchaseList" border style="width: 100%">
                    <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="outCode" label="出库单号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="recomName" label="服务商名称" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="warehouseName" label="仓库名称" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="outCount" label="出库数量" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="outStatusName" label="状态" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="operator" label="出库人" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="inputTime" label="出库时间" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" width="200" align="center">
                      <template slot-scope="scope">
                        <el-button
                          class="btn btn-warning btn-sm ButtonColor"
                          size="small"
                          :disabled="scope.row.orderStatus == 2"
                          @click="ReviewClick(scope.row)"
                          >审核
                        </el-button>
                        <el-button
                          class="btn btn-primary btn-sm ButtonColor"
                          size="small"
                          @click="DetailClick(scope.row)"
                          >出库单详情
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="PaginationStyle">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="pageindex"
                      :page-sizes="[10,20,50,100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      background
                      :total="totalCount"
                    ></el-pagination>
                  </div>
                </div>
                <!-- end panel-body -->
              </div>
              <!-- end panel -->
            </div>
            <!-- end col-10 -->
          </div>
          <!-- end row -->
        </div>
        <!-- end #content -->
      </div>
      <el-dialog title :visible.sync="outerVisible" width="500px">
        <div class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">请确定出库单的商品与数量</div>
          <div class="swal-footer">
            <div class="swal-button-container">
              <div class="swal-button swal-button--confirm btn btn-primary" :disabled="disabled" @click="MakeSure">同意审核</div>
            </div>
            <div class="swal-button-container">
              <div class="swal-button swal-button--cancel btn btn-warning"  @click="CancleSure('reasonValidForm')">拒绝审核</div>
            </div>
          </div>
          <el-form :model="reasonValidForm" ref="reasonValidForm" label-width="100px" class="demo-ruleForm">
            <el-form-item
              label="驳回理由"
              prop="rejectReason"
              :rules="[
                { required: true, message: '驳回理由不能为空',trigger: 'blur'}
              ]"
            >
              <el-input placeholder="请输入驳回原因" v-model="reasonValidForm.rejectReason" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
  
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "Outbound",
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      disabled: false,
      CurrentSelection: [],
      purchaseList:[],
      outCode:'',
      recomId:"",
      TimeValue: "",
      recomList: [],
      director:0,
      reasonValidForm: {
        rejectReason: ''
      },
    };
  },
  mounted: function() {
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initdata();
    this.getRecomList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    ReviewClick(row){
      this.outerVisible = true;
      this.CurrentSelection = row;
    },
    DetailClick(item){
      this.$router.push({ 
        path: "/outbounddetail",
        query:{outId:item.outId,checkId:2}
      });
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    MakeSure() {
      let that = this;
      that.disabled = true;
      const options = {
        url: "/distribution/B2cTobOutController/checkOrder",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director,
          outId: that.CurrentSelection.outId,
          status: 2,
        })
      };
      axios(options).then(function(response) {
        that.outerVisible = false;
        that.disabled = false;
        if (response.data.code == 200) {
          that.initdata();
          that.$notify({
            title: "成功",
            message: response.data.message,
            type: "success"
          });
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          that.outerVisible = false;
          http.handleHttpError(error, that);
        });
    },
    CancleSure(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          that.disabled = true;
          const options = {
            url: "/distribution/B2cTobOutController/checkOrder",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: Qs.stringify({
              director: that.director,
              outId: that.CurrentSelection.outId,
              status: 0,
              note: that.reasonValidForm.rejectReason
            })
          };
          axios(options).then(function(response) {
            that.outerVisible = false;
            that.disabled = false;
            if (response.data.code === 200) {
              that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(error => {
            that.outerVisible = false;
            http.handleHttpError(error, that);
          });
        } 
      });
    },
    initdata() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOutController/queryOutInfo",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          outStatusList:[1],
          outCode: that.outCode,
          recomId: that.recomId,
          startInputTime: that.startTime,
          endInputTime: that.endTime,
          size: that.pageSize,
          current: that.pageNo,
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.purchaseList = response.data.data.records;
          that.totalCount = response.data.data.total;
          for (var i in response.data.data.records) {
            response.data.data.records[i].ordernumber =
              Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
            if (response.data.data.records[i].outStatus == 0) {
              response.data.data.records[i].outStatusName = "审核拒绝";
            }else if(response.data.data.records[i].outStatus == 1){
              response.data.data.records[i].outStatusName = "待审核";
            }else if(response.data.data.records[i].outStatus == 2){
              response.data.data.records[i].outStatusName = "审核通过";
            }
          }
        } else {
          http.handleHttpError(error, that);
        }
      })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    // 获取服务商列表
    getRecomList() {
      let that = this;
      const options = {
        url: "distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.recomList = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    ChangeDate(){
      this.ruleForm.depositTime = this.FormatAllDate(this.ruleForm.depositTime);
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    FormatSpecialDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;

      return currentdate;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth{
  width:202px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/OutboundReviews.vue